module.exports = __webpack_public_path__ + "img/avatar.47e495b8.jpg";